import { Plus } from 'lucide-react';
import { useState } from 'react';
import NodeTypeModal from './NodeTypeModal';
import type { NodeType, NodeCategory } from '../constants/nodeCategories';

interface SidebarProps {
    onAddNode: (nodeType: NodeType) => void;
    categories?: NodeCategory[];
}

export default function Sidebar({ onAddNode, categories }: SidebarProps) {
    const [isOpen, setIsOpen] = useState(false);

    const handleAddNode = (type: NodeType) => {
        onAddNode(type);
        setIsOpen(false);
    };

    return (
        <>
            <NodeTypeModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onSelect={handleAddNode}
                categories={categories}
            />

            {/* Botão Flutuante - Top Right (ManyChat style) */}
            <button
                onClick={() => setIsOpen(true)}
                className="absolute right-5 top-5 w-12 h-12 bg-[#2196F3] hover:bg-[#1976D2] rounded-full shadow-lg flex items-center justify-center text-white transition-all z-30 hover:scale-110 hover:shadow-xl"
                title="Adicionar nó"
            >
                <Plus className="w-6 h-6" strokeWidth={2.5} />
            </button>
        </>
    );
}
